(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jar-flavor-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-jar-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('.jar-flavor-carousel__track');
      const slides = carousel.querySelectorAll('[data-jar-slide]');
      const previous = carousel.querySelector('[data-jar-prev]');
      const next = carousel.querySelector('[data-jar-next]');

      if (!track || slides.length < 2) return;

      const move = (direction) => {
        track.scrollBy({
          left: track.clientWidth * direction,
          behavior: 'smooth'
        });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-store-locator]').forEach((locator) => {
      const search = locator.querySelector('[data-store-search]');
      const cards = [...locator.querySelectorAll('[data-store-card]')];
      const map = locator.querySelector('[data-store-map]');
      const noResults = locator.querySelector('[data-no-results]');

      const createMapUrl = (latitude, longitude) => {
        const lat = Number(latitude);
        const lon = Number(longitude);

        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

        const longitudePadding = 0.012;
        const latitudePadding = 0.008;

        const bbox = [
          lon - longitudePadding,
          lat - latitudePadding,
          lon + longitudePadding,
          lat + latitudePadding
        ].join(',');

        return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`;
      };

      const setActiveStore = (card) => {
        cards.forEach((item) => item.classList.remove('is-active'));
        card.classList.add('is-active');

        const mapUrl = createMapUrl(
          card.dataset.latitude,
          card.dataset.longitude
        );

        if (mapUrl && map) {
          map.src = mapUrl;
        }
      };

      cards.forEach((card) => {
        card.querySelector('[data-store-select]')?.addEventListener('click', () => {
          setActiveStore(card);
        });
      });

      const firstStoreWithCoordinates = cards.find((card) => {
        return createMapUrl(
          card.dataset.latitude,
          card.dataset.longitude
        );
      });

      if (firstStoreWithCoordinates) {
        setActiveStore(firstStoreWithCoordinates);
      }

      search?.addEventListener('input', () => {
        const term = search.value.trim().toLowerCase();
        let matches = 0;

        cards.forEach((card) => {
          const isMatch = card.dataset.searchText.includes(term);
          card.hidden = !isMatch;

          if (isMatch) matches += 1;
        });

        if (noResults) {
          noResults.hidden = matches !== 0;
        }

        const firstVisibleStoreWithCoordinates = cards.find((card) => {
          return !card.hidden && createMapUrl(
            card.dataset.latitude,
            card.dataset.longitude
          );
        });

        if (firstVisibleStoreWithCoordinates) {
          setActiveStore(firstVisibleStoreWithCoordinates);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
